export default "__VITE_ASSET__CNu3WWb6__"